import React, { useState } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useApiAuth } from "../hooks/useApiAuth";
import { useSearch } from "../contexts/SearchContext";
import { useGlobalSearch } from "../contexts/GlobalSearchContext";
import TimesheetAnalysis from "../components/TimesheetAnalysis";

export const FounderPage: React.FC = () => {
  const { isApiReady, isLoading: authLoading, error: authError } = useApiAuth();
  const { setSearchTerm } = useSearch();
  const { clearGlobalSearch } = useGlobalSearch();
  const [activeTab, setActiveTab] = useState("timesheet-analysis");

  // Handle tab change and clear search
  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey);
    // Clear both local and global search when switching tabs
    setSearchTerm("");
    clearGlobalSearch();
  };

  const founderTabs = [
    {
      key: "timesheet-analysis",
      label: "Timesheet Analysis",
      icon: "pi pi-chart-bar",
      component: <TimesheetAnalysis />,
    },
    // Add more tabs here as needed in the future
  ];

  if (!isApiReady) {
    return (
      <div className="page-container">
        <Card title="Founder Dashboard">
          <div className="flex justify-content-center">
            {authLoading ? (
              <div>Loading authentication...</div>
            ) : authError ? (
              <div className="text-red-500">
                Authentication error: {authError}
              </div>
            ) : (
              <div>Waiting for authentication...</div>
            )}
          </div>
        </Card>
      </div>
    );
  }

  const currentTabData =
    founderTabs.find((tab) => tab.key === activeTab) || founderTabs[0];

  return (
    <div className="page-container">
      {/* Custom navigation */}
      <div className="founder-nav mb-4">
        <div className="flex flex-wrap gap-2">
          {founderTabs.map((tab) => (
            <Button
              key={tab.key}
              label={tab.label}
              icon={tab.icon}
              className={`p-button-sm ${
                activeTab === tab.key
                  ? "p-button-primary"
                  : "p-button-outlined p-button-secondary"
              }`}
              onClick={() => handleTabChange(tab.key)}
            />
          ))}
        </div>
      </div>
      <Card>
        {/* Content area */}
        {currentTabData.component}
      </Card>
    </div>
  );
};
